import styled from "styled-components"

import {IconButton, IconTypes} from "@irati/ui/src/Button"

const Trashcan = styled(IconButton).attrs({icon: IconTypes.bin})`
  position: absolute;
  right: 0;
  top: -10px;
`

export default Trashcan
